import React from 'react'
import { useSelector } from 'react-redux'
import Wysiwyg from '../wysiwyg'
import Form from './form'
import slugify from 'slugify'

import roundShape from '../../icons/round-shape.svg'
import quadShape from '../../icons/quad-shape.svg'

import trads from '../../intl/trads.json'

const FormSection = ({data, searchQuery}) => {
  const lang = useSelector(state => state.lang)
  const formLegals = (data.formLegals) ? data.formLegals : null
  const formTitle = (data.formTitle.formTitle) ? data.formTitle.formTitle : data.formTitle

  return (
    <div className="slice has-full-bg contact slice--bg" data-anchor={formTitle} id={`${slugify(formTitle, {remove: /[*+~.,()'"!?:@,]/g}).toLocaleLowerCase()}`}>
      <svg className={`absolute icon-beige contact__quad`} width="120px" height="120px">
        <use xlinkHref={quadShape.url} />
      </svg>
      <svg className={`absolute icon-night contact__round`} width="65px" height="65px">
        <use xlinkHref={roundShape.url} />
      </svg>

      <div className="row">
        <div className="col-12 lg-col-8">
          { searchQuery === ''
          ? <>
              <Form data={data} searchQuery={searchQuery} />
              <div className="contact-legals mt-10">
                <Wysiwyg document={formLegals} />
              </div>
            </>
          :  <section className="contact-success text-center">
                <p className="title title--white title-small">{trads[lang].contact.successTitle}</p>
                <p className="paragraph-big paragraph-big--white">{trads[lang].contact.successMsg}</p>
              </section> 
          }
        </div>
      </div>
    </div>
  )
}

export default FormSection